export class AvisInitialTypeLight {

	public datePublication: string;
	public idWeb: string;

	constructor() {
		this.datePublication = '';
		this.idWeb = '';

	}
}
